// VFX: Word Highlight Reveal
// Category: text-emphasis · Tags: text, highlight, reveal, callout, word
// Uma palavra ou frase recebe highlight animado (fundo colorido que expande).
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface WordHighlightRevealProps {
  before?: string;
  highlighted?: string;
  after?: string;
  highlightColor?: string;
  textColor?: string;
  fontSize?: number;
  delay?: number;
}

export default function WordHighlightReveal({
  before = "Pull from ",
  highlighted = "anywhere",
  after = ".",
  highlightColor = "#10b981",
  textColor = "#f8fafc",
  fontSize = 64,
  delay = 5,
}: WordHighlightRevealProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const textP = spring({ frame, fps, config: { damping: 200, stiffness: 120 } });
  const hlP = spring({ frame: frame - delay, fps, config: { damping: 160, stiffness: 180 } });
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", padding: "0 60px", background: "#0a0e1a" }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.2em", justifyContent: "center", alignItems: "center", opacity: textP, transform: `translateY(${interpolate(textP, [0, 1], [20, 0], clamp)}px)` }}>
        {before && <span style={{ fontSize, fontWeight: 700, fontFamily: "system-ui", color: textColor }}>{before}</span>}
        <span style={{ position: "relative", display: "inline-flex", alignItems: "center", fontSize, fontWeight: 700, fontFamily: "system-ui", color: highlightColor, padding: "2px 14px" }}>
          <span style={{ position: "absolute", inset: 0, borderRadius: 8, background: `${highlightColor}26`, border: `1.5px solid ${highlightColor}66`, transform: `scaleX(${hlP}) scaleY(${interpolate(hlP, [0, 1], [0.6, 1], clamp)})`, transformOrigin: "left center" }} />
          <span style={{ position: "relative" }}>{highlighted}</span>
        </span>
        {after && <span style={{ fontSize, fontWeight: 700, fontFamily: "system-ui", color: textColor }}>{after}</span>}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
